import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ExternalUserCheckService } from '../services/external-user-check-service/external-user-check-service.service'; // Replace with your actual auth service

export const internalUserGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(ExternalUserCheckService);
  
  // Get user information from your auth service
  const isExternalUser = authService.isExternalUser();
  
  if (isExternalUser) {
    console.warn('External user attempted to access internal route:', state.url);
    router.navigate(['/home/landing-page']);
    return false;
  }
  
  return true;
};